import React from "react";
import { BrowserRouter as Router, Route, Switch, withRouter } from "react-router-dom";
import PageNotFound from "../../Component/NotFound/index";
import HrLetters from "./HrLetters";
import HrDrive from "./HrDrive";

const OrganisationRoutes = ({ match }) => (
  <div>
    <Switch>
      <Route path={`${match.path}/letter`} component={HrLetters} />
      <Route exact path={`${match.path}/drive`} component={HrDrive} />
      <Route path="**" component={PageNotFound} />
    </Switch>
  </div>
);

export default withRouter(OrganisationRoutes);
